// extracted by mini-css-extract-plugin
module.exports = {"buttons":"CreditorForm_buttons__3hjKj","loadingBox":"CreditorForm_loadingBox__3fwvG","validating":"CreditorForm_validating__1BL9A"};